export const baseURL = "https://dev.api.qtradeview.com" // development/staging
//
// FIX Engine URL - Main API gateway with JWT auth (HTTPS: 7261, HTTP: 5116)
// export const baseURL = "https://localhost:7261";
export const secureEndPoint = "api/secure";
export const publicEndpoint = "api/public";
export const generalEndpoint = "api";

// DataFeed Server URL - for Q AI Prompt Management & Data APIs
// Prompt Admin endpoints: /api/q/admin/prompts/*
// User Data endpoints: /api/q/users/*
// Note: Port 7261 is DataFeed direct, but should go through FIX Engine (5116) in production
export const dataFeedURL = "http://localhost:5100";

// Google OAuth Client ID for Q AI
export const GOOGLE_CLIENT_ID = "282730540818-q9195uu434157psduf2qt2cg1bf30rj3.apps.googleusercontent.com";

// QBridge Download Configuration
// Environment-based CDN configuration for QBridge installer (Windows)
// Local: http://localhost:port or http://local-domain
// Production: https://cdn.qforgex.com

// Environment detection
const isLocalEnvironment = window.location.hostname === 'localhost' ||
                           window.location.hostname === '127.0.0.1' ||
                           window.location.hostname.includes('.local');

// Download Server Configuration per environment
export const QBRIDGE_CDN_CONFIG = {
  // Local development - no SSL, localhost or local domain
  local: {
    protocol: 'http',
    domain: 'localhost:8080',  // Change this to your local file server
    path: '/downloads'
  },
  // Production - SSL required, main qforgex.com domain (no CDN subdomain)
  production: {
    protocol: 'https',
    domain: 'qforgex.com',
    path: '/downloads'
  }
};

// Active CDN config based on environment
const activeCDNConfig = isLocalEnvironment ? QBRIDGE_CDN_CONFIG.local : QBRIDGE_CDN_CONFIG.production;

// QBridge download settings
export const QBRIDGE_FILENAME = "QBridge-Setup-2.2.1.exe";
export const QBRIDGE_VERSION = "2.2.1";
export const QBRIDGE_SIZE = "15 MB";

// Computed download URL (automatically uses correct environment)
export const QBRIDGE_DOWNLOAD_URL = `${activeCDNConfig.protocol}://${activeCDNConfig.domain}${activeCDNConfig.path}/${QBRIDGE_FILENAME}`;

// Legacy export for backward compatibility
export const QBRIDGE_CDN_DOMAIN = activeCDNConfig.domain;

/**
 * Generate download URL with custom domain/filename
 * Handles both full URLs (http://...) and domain-only inputs
 *
 * @param {string} domainOrUrl - Domain name or full URL (e.g., "cdn.example.com" or "https://cdn.example.com")
 * @param {string} filename - Installer filename (default: QBridge-Setup-latest.exe)
 * @param {string} path - Download path (default: /downloads)
 * @returns {string} Full download URL
 *
 * @example
 * getQBridgeDownloadUrl("cdn.qforgex.com", "QBridge-v2.1.0.exe")
 * // Returns: "https://cdn.qforgex.com/downloads/QBridge-v2.1.0.exe"
 *
 * @example
 * getQBridgeDownloadUrl("http://localhost:8080", "QBridge-Setup.exe")
 * // Returns: "http://localhost:8080/downloads/QBridge-Setup.exe"
 */
export const getQBridgeDownloadUrl = (
  domainOrUrl = activeCDNConfig.domain,
  filename = QBRIDGE_FILENAME,
  path = '/downloads'
) => {
  // Check if input already contains protocol (http:// or https://)
  if (domainOrUrl.startsWith('http://') || domainOrUrl.startsWith('https://')) {
    // Full URL provided - use as-is
    const baseUrl = domainOrUrl.replace(/\/$/, ''); // Remove trailing slash if present
    return `${baseUrl}${path}/${filename}`;
  }

  // Domain only - determine protocol based on environment
  // Use HTTPS for production domains, HTTP for localhost/local
  const isLocalDomain = domainOrUrl.includes('localhost') ||
                        domainOrUrl.includes('127.0.0.1') ||
                        domainOrUrl.includes('.local');
  const protocol = isLocalDomain ? 'http' : 'https';

  return `${protocol}://${domainOrUrl}${path}/${filename}`;
};

// Q.AI Admin API Routing Configuration
// When true: Frontend calls DataFeed directly (dev mode, FIX Engine not running)
// When false: Frontend calls FIX Engine which proxies to DataFeed (production mode)
export const USE_DIRECT_DATAFEED = false;

// Q.AI Admin API base URL resolver
// Returns the correct base URL and path prefix based on routing mode
export const getQAIAdminConfig = () => {
  if (USE_DIRECT_DATAFEED) {
    return {
      baseUrl: dataFeedURL,
      pathPrefix: '/api/q/admin'  // DataFeed direct path
    };
  }
  return {
    baseUrl: baseURL,
    pathPrefix: '/api/admin/qai'  // FIX Engine proxy path
  };
};

// QuantX Analytics Configuration
// Real-time trading analytics endpoints on DataFeed Server
export const QUANTX_CONFIG = {
  // Base URL for QuantX API (always on DataFeed Server)
  baseUrl: `${dataFeedURL}/api/quantx`,

  // Default symbol for testing
  defaultSymbol: 'XAUUSD_ct',

  // Auto-refresh interval (milliseconds)
  refreshInterval: 30000,

  // Enable QuantX Analytics feature
  enabled: true
};

// QuantX API URL resolver
export const getQuantXConfig = () => {
  return {
    baseUrl: QUANTX_CONFIG.baseUrl,
    defaultSymbol: QUANTX_CONFIG.defaultSymbol,
    refreshInterval: QUANTX_CONFIG.refreshInterval,
    enabled: QUANTX_CONFIG.enabled
  };
};

// ═══════════════════════════════════════════════════════════════════════════════
// PAYMENT CONFIGURATION - Feature Flags
// ═══════════════════════════════════════════════════════════════════════════════

/**
 * Payment Provider Feature Flag
 *
 * USE_NOWPAY_PAYMENTS: Controls which payment system is active
 * - true:  Use NOWPayments (USDT TRC20 crypto) - New system
 * - false: Use legacy Stripe checkout - Fallback
 *
 * IMPORTANT: Set to false to rollback to legacy payment if issues arise
 */
export const USE_NOWPAY_PAYMENTS = true;

// Support Contact (used in payment pages)
export const SUPPORT_EMAIL = "info@qforgex.com";

// Payment polling configuration
export const PAYMENT_CONFIG = {
  // Polling interval for payment status (milliseconds)
  pollInterval: 3000,

  // Maximum polling time before timeout (15 minutes)
  maxPollTime: 15 * 60 * 1000,

  // Maximum pending payments per user
  maxPendingPayments: 3,

  // Payment success redirect delay (milliseconds)
  successRedirectDelay: 3000
};
